import React, { FunctionComponent, useState } from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import AddPlaylistModal from '../AddPlaylistModal'

import * as P from '../../PlaylistProps'

import {
  PlayListComponentEmptyPageContainer,
  PlayListEmptyPageContainer,
  PlayListEmptyPageText,
} from './styles'

const PlayListComponentEmptyPage: FunctionComponent<P.PlayListComponentEmptyPageProps> = ({
  checkPlaylist,
  getCuratorRank,
  setRecentlyAddedPlaylist,
}) => {
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)

  return (
    <PlayListComponentEmptyPageContainer>
      <PlayListEmptyPageContainer>
        <PlayListEmptyPageText>
          <div>{t('playlistsPage.emptyPlaylists')}</div>
          <div>{t('playlistsPage.getStarted')}</div>
        </PlayListEmptyPageText>

        <AddPlaylistModal
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          getCuratorRank={getCuratorRank}
          setRecentlyAddedPlaylist={setRecentlyAddedPlaylist}
          empty
          onCheckPlaylist={checkPlaylist}
        />
      </PlayListEmptyPageContainer>
    </PlayListComponentEmptyPageContainer>
  )
}

export default PlayListComponentEmptyPage
